import React, { useEffect, useState, useRef } from "react";
import Header from "../../../Componets/Header";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import Loadercomponent from "../../../Componets/Loader";
import { Button } from "antd";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { registerCairoFont } from "../cairo-font";
import ScrollWrapper from "../../../Componets/ScrollWrapper";
import ReactToPrint from "react-to-print";
import formatDateDDMMYYYY from "../../../Main/formatDate";
import {
  DoubleLeftOutlined,
  LeftOutlined,
  RightOutlined,
  DoubleRightOutlined
} from "@ant-design/icons";
import { get_all_sales_returns } from "../../../Controllers/Sales/Returns";


const SalesReturnReport = () => {
  let location = useLocation();
  let componentRef = useRef();

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState(null);
  const [role, setRole] = useState("");
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalCount: 0
  });
  const [goToPage, setGoToPage] = useState("");

  const headers = {
    name: "Sales Returns",
    components: [
      {
        type: "search",
        name: "search",
        placeholder: "Search by invoice number or customer",
        value: "",
      },
      {
        type: "select",
        name: "sort",
        placeholder: "Sort",
        allowClear: true,
        showSearch: false,
        filterOption: true,
        value: null,
        options: [
          { value: "0", label: "Date (Newest)" },
          { value: "1", label: "Date (Oldest)" },
          { value: "2", label: "Amount (High-Low)" },
          { value: "3", label: "Amount (Low-High)" },
        ],
      },
      {
        type: "filter",
        name: "customer",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Customer",
        api: "get-all-customers",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "branch",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Branch",
        api: "get-all-branches",
        value: null,
        options: null,
      },
      /*   {
          type: "filter",
          name: "status",
          placeholder: "Status",
          value: null,
          allowClear: true,
          showSearch: false,
          filterOption: true,
          options: [
            { value: "0", label: "Inactive" },
            { value: "1", label: "Active" },
          ],
        }, */
      {
        type: "range",
        name: "date",
        value: {
          start: "",
          end: "",
        },
      },
      {
        type: "range",
        name: "due_date",
        value: {
          start: "",
          end: "",
        },
      },
    ],
    navigate: {
      tabs: [
        {
          name: "Reports",
          path: "/app/reports",
        },
        {
          name: "Sales Returns",
          path: ""
        }
      ],
      total: [
        { value: 0, label: "Total Returns" },
        { value: 0, label: "Active" },
        { value: "0", label: "Inactive" },
      ],
    },
  };

  const [header, setHeader] = useState(headers);
  const [filters, setFilters] = useState({});

  const formdata = (data) => {
    setFilters(data);
    fetchData(data, 1);
  };

  const fetchData = async (tabledata, page = 1) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search || "",
        sort: tabledata?.sort || null,
        customer: tabledata?.customer || null,
        branch: tabledata?.branch || null,
        status: tabledata?.status || null,
        date: tabledata?.date || { start: "", end: "" },
        due_date: tabledata?.due_date || { start: "", end: "" },
        page: page
      };

      const response = await get_all_sales_returns(data);

      if (response?.status) {
        setBody(response?.data?.data || []);
        setRole(response?.data?.role || "");

        setPagination({
          currentPage: response?.data?.currentPage || 1,
          totalPages: response?.data?.totalPages || 1,
          totalCount: response?.data?.totalCount || 0
        });

        const activeCount = response?.data?.data?.filter(item => item?.status === 1)?.length || 0;
        const inactiveCount = response?.data?.data?.filter(item => item?.status === 0)?.length || 0;

        setHeader(prev => ({
          ...prev,
          navigate: {
            ...prev.navigate,
            total: [
              { value: response?.data?.totalCount || 0, label: "Total Returns" },
              { value: activeCount, label: "Active" },
              { value: inactiveCount, label: "Inactive" },
            ]
          }
        }));

        setLoader(false);
      } else {
        toast?.error(response?.message || "Failed to fetch sales returns");
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message || "An error occurred");
      setLoader(false);
    }
  };

  const paginationdata = (paginationData) => {
    fetchData(filters, paginationData.currentPage);
  };

  useEffect(() => {
    fetchData({});
  }, []);

  useEffect(() => {
    if (!role) return;

    let updatedHeader = { ...headers };

    if (role !== "SUPERADMIN") {
      updatedHeader.components = updatedHeader.components.filter(
        (item) => item.name !== "branch"
      );
    }

    setHeader(updatedHeader);
  }, [role]);

  const handlePageChange = (page) => {
    let data = {
      ...pagination,
      currentPage: page,
    };
    paginationdata(data);
    setGoToPage("");
  };

  const handleNext = () => {
    let currentPage = parseInt(pagination?.currentPage) + 1;

    if (currentPage <= parseInt(pagination?.totalPages)) {
      handlePageChange(currentPage);
    }
  };

  const handlePrevious = () => {
    let currentPage = parseInt(pagination?.currentPage) - 1;

    if (currentPage > 0) {
      handlePageChange(currentPage);
    }
  };

  const handleFirst = () => {
    handlePageChange(1);
  };

  const handleLast = () => {
    handlePageChange(pagination?.totalPages);
  };

  const handleGoToPage = () => {
    const pageNumber = parseInt(goToPage);
    if (pageNumber && pageNumber >= 1 && pageNumber <= pagination?.totalPages) {
      handlePageChange(pageNumber);
    } else {
      setGoToPage("");
    }
  };

  const generatePageNumbers = () => {
    const currentPage = parseInt(pagination?.currentPage) || 1;
    const totalPages = parseInt(pagination?.totalPages) || 1;
    const pages = [];

    if (totalPages <= 10) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 6) {
        for (let i = 1; i <= 9; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 5) {
        pages.push(1);
        pages.push('...');
        for (let i = totalPages - 8; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        pages.push('...');
        for (let i = currentPage - 4; i <= currentPage + 4; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(totalPages);
      }
    }

    return pages;
  };

  const downloadCSV = () => {
    console.log("Download CSV clicked");

    if (!body || body.length === 0) {
      console.log("No data available for download");
      toast.error("No data available to download");
      return;
    }

    try {
      const header = ["Return No", "Invoice No", "Customer", "Branch", "Date", "Subtotal", "Discount", "Tax [VAT]", "Delivery", "Total", "Payment Status", "Delivery Status"];

      const rows = body.map((item) => {
        const paymentStatusMap = {
          0: "Pending",
          1: "Partially Paid",
          2: "Paid"
        };

        const deliveryStatusMap = {
          0: "Pending",
          1: "Processing",
          2: "Delivered"
        };

        const row = [
          item?.number ? `#RET-${item.number}` : "-",
          item?.ref ? `#INV-${item.ref}` : "-",
          item?.customer?.name ? item?.customer?.name : "Walk-in Customer",
          item?.branch?.name || "-",
          item?.date ? formatDateDDMMYYYY(item.date) : "-",
          item?.subtotal?.toFixed?.(3) || "0.000",
          item?.discount?.toFixed?.(3) || "0.000",
          item?.taxamount?.toFixed?.(3) || "0.000",
          item?.delivery?.toFixed?.(3) || "0.000",
          item?.total?.toFixed?.(3) || "0.000",
          paymentStatusMap[item?.payment_status] || "Pending",
          deliveryStatusMap[item?.delivery_status] || "Pending",
        ];
        return row;
      });

      const csvContent = [header, ...rows]
        .map(row => row.map(field => `"${field}"`).join(","))
        .join("\n");

      const encoder = new TextEncoder();
      const encodedContent = encoder.encode('\uFEFF' + csvContent);

      const blob = new Blob([encodedContent], { type: 'text/csv;charset=utf-8' });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.setAttribute("href", url);
      link.setAttribute("download", `Sales_Return_Report_${new Date().toLocaleDateString().replace(/\//g, '_')}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      toast.success("CSV downloaded successfully");

    } catch (error) {
      console.error("Error generating CSV:", error);
      toast.error("Failed to generate CSV file");
    }
  };

  const downloadPDF = () => {
    if (!body || body.length === 0) {
      toast.error("No data available to download");
      return;
    }

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    registerCairoFont(doc);
    const pageWidth = doc.internal.pageSize.getWidth();

    doc.setFont("Cairo-Bold", "bold");

    doc.setFontSize(18);
    doc.text("Sales Return Report", pageWidth / 2, 18, { align: "center" });

    const now = new Date();
    const formattedDate = now.toLocaleDateString("en-GB");
    const formattedTime = now.toLocaleTimeString();
    doc.setFontSize(10);
    doc.text(`Downloaded on: ${formattedDate} ${formattedTime}`, pageWidth / 2, 26, { align: "center" });

    const tableRows = body.map((item) => {
      const paymentStatusMap = {
        0: "Pending",
        1: "Partially Paid",
        2: "Paid"
      };

      const deliveryStatusMap = {
        0: "Pending",
        1: "Processing",
        2: "Delivered"
      };

      return [
        item?.number ? `#RET-${item.number}` : "-",
        item?.ref ? `#INV-${item.ref}` : "-",
        item?.customer?.name || "Walk-in Customer",
        item?.branch?.name || "-",
        item?.date ? formatDateDDMMYYYY(item.date) : "-",
        item?.subtotal?.toFixed?.(3) || "0.000",
        item?.discount?.toFixed?.(3) || "0.000",
        item?.taxamount?.toFixed?.(3) || "0.000",
        item?.delivery?.toFixed?.(3) || "0.000",
        item?.total?.toFixed?.(3) || "0.000",
        paymentStatusMap[item?.payment_status] || "Pending",
        deliveryStatusMap[item?.delivery_status] || "Pending",
      ];
    });

    autoTable(doc, {
      startY: 32,
      head: [[
        "Return No", "Invoice No", "Customer", "Branch", "Date",
        "Subtotal", "Discount", "Tax [VAT]", "Delivery", "Total",
        "Payment Status", "Delivery Status"
      ]],
      body: tableRows,
      styles: {
        font: "Cairo",
        textColor: [0, 0, 0],
        lineColor: [7, 181, 83],
        lineWidth: 0.2
      },
      headStyles: {
        font: "Cairo",
        fontStyle: "bold",
        fillColor: false,
        lineColor: [7, 181, 83],
        lineWidth: 0.6
      },
    });

    doc.save(`Sales_Return_Report_${formattedDate}.pdf`);
    toast.success("PDF downloaded successfully");
  };

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <div className="text-right flex gap-3 justify-end mt-4">
          <Button
            className="mr-2 !bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"
            type="primary"
            onClick={downloadCSV}
          >
            Download CSV
          </Button>

          <ReactToPrint
            trigger={() => (
              <Button
                className="mr-2 !bg-[#07b553] !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]"
                type="primary"
              >
                Download PDF
              </Button>
            )}
            content={() => componentRef}
            pageStyle={`
              @page {
                size: landscape;
                margin: 10mm;
              }
              
              @media print {
                tfoot {
                  position: static !important;
                  bottom: auto !important;
                }
                thead { 
                  display: table-header-group !important;
                }
                tfoot {
                  display: table-row-group !important;
                }
              }
              
              table, thead, tbody, tfoot, tr, th, td {
                padding: 2px !important; 
                font-size: 10px !important; 
              }
              
              th, td {
                border: 1px solid #ddd;
              }
              
              th {
                background-color: #f4f4f4;
              }
              
              @media print {
                table, thead, tbody, tfoot, tr, th, td {
                  border: 1px solid #000 !important;
                }
                
                th {
                  background-color: #f4f4f4 !important;
                  -webkit-print-color-adjust: exact !important;
                  print-color-adjust: exact !important;
                }
                
                table {
                  width: 100% !important;
                  border-collapse: collapse !important;
                }
                
                thead, tfoot {
                  position: static !important;
                }
              }
            `}
          />
        </div>

        <ScrollWrapper>
          <div
            className="max-h-[70vh] overflow-y-auto scrollbar-hide remove-scroll-limit"
            ref={(el) => (componentRef = el)}
          >
            <table className="w-full bg-white">
              <thead className="text-gray-500 sticky top-0 bg-white z-10">
                <tr>
                  <th className="border p-4">Return No</th>
                  <th className="border p-4">Invoice No</th>
                  <th className="border p-4">Customer</th>
                  <th className="border p-4">Branch</th>
                  <th className="border p-4">Date</th>
                  <th className="border p-4">Subtotal</th>
                  <th className="border p-4">Discount</th>
                  <th className="border p-4">Tax [VAT]</th>
                  <th className="border p-4">Delivery</th>
                  <th className="border p-4">Total</th>
                  <th className="border p-4">Payment Status</th>
                  <th className="border p-4">Delivery Status</th>
                </tr>
              </thead>
              <tbody>
                {body?.map((value, index) => {
                  const paymentStatusMap = {
                    0: { text: "Pending", color: "text-yellow-600" },
                    1: { text: "Partially Paid", color: "text-blue-600" },
                    2: { text: "Paid", color: "text-green-600" }
                  };

                  const deliveryStatusMap = {
                    0: { text: "Pending", color: "text-yellow-600" },
                    1: { text: "Processing", color: "text-blue-600" },
                    2: { text: "Delivered", color: "text-green-600" }
                  };

                  return (
                    <tr key={value._id || index}>
                      <td className="border p-4">#RET {value?.number}</td>
                      <td className="border p-4">
                        {value?.ref ? `#INV ${value.ref}` : "-"}
                      </td>
                      <td className="border p-4">
                        {value?.customer?.name || "Walk-in Customer"}
                      </td>
                      <td className="border p-4">
                        {value?.branch?.name || "-"}
                      </td>
                      <td className="border p-4">
                        {value?.date
                          ? formatDateDDMMYYYY(value?.date)
                          : ""}
                      </td>
                      <td className="border p-4">
                        {value?.subtotal?.toFixed?.(3)}
                      </td>
                      <td className="border p-4">
                        {value?.discount?.toFixed?.(3)}
                      </td>
                      <td className="border p-4">
                        {value?.taxamount?.toFixed?.(3)}
                      </td>
                      <td className="border p-4">
                        {value?.delivery?.toFixed?.(3)}
                      </td>
                      <td className="border p-4 font-medium">
                        {value?.total?.toFixed?.(3)}
                      </td>
                      <td className={`border p-4 ${paymentStatusMap[value?.payment_status]?.color || "text-gray-600"}`}>
                        {paymentStatusMap[value?.payment_status]?.text || "Pending"}
                      </td>
                      <td className={`border p-4 ${deliveryStatusMap[value?.delivery_status]?.color || "text-gray-600"}`}>
                        {deliveryStatusMap[value?.delivery_status]?.text || "Pending"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot className="sticky bottom-0 bg-white z-10">
                <tr className="text-sm font-medium">
                  <td className="border p-4 font-bold" colSpan="5">Total</td>
                  <td className="border p-4 text-medium font-bold">
                    {body
                      ?.reduce(
                        (acc, currentValue) =>
                          parseFloat(acc) + parseFloat(currentValue?.subtotal || 0),
                        0
                      )
                      ?.toFixed(3)}
                  </td>
                  <td className="border p-4 text-medium font-bold">
                    {body
                      ?.reduce(
                        (acc, currentValue) =>
                          parseFloat(acc) + parseFloat(currentValue?.discount || 0),
                        0
                      )
                      ?.toFixed(3)}
                  </td>
                  <td className="border p-4 text-medium font-bold">
                    {body
                      ?.reduce(
                        (acc, currentValue) =>
                          parseFloat(acc) + parseFloat(currentValue?.taxamount || 0),
                        0
                      )
                      ?.toFixed(3)}
                  </td>
                  <td className="border p-4 text-medium font-bold">
                    {body
                      ?.reduce(
                        (acc, currentValue) =>
                          parseFloat(acc) + parseFloat(currentValue?.delivery || 0),
                        0
                      )
                      ?.toFixed(3)}
                  </td>
                  <td className="border p-4 text-medium font-bold">
                    {body
                      ?.reduce(
                        (acc, currentValue) =>
                          parseFloat(acc) + parseFloat(currentValue?.total || 0),
                        0
                      )
                      ?.toFixed(3)}
                  </td>
                  <td className="border p-4"></td>
                  <td className="border p-4"></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </ScrollWrapper>

        {/* Advanced Pagination */}
        {pagination?.currentPage ? (
          <div className="border-t p-4 bg-white sticky bottom-0 z-20">
            <div className="flex justify-between items-center text-gray-600 text-sm font-medium w-full">
              <div className="flex items-center">
                <span className="pr-3">TOTAL</span>
                <span>
                  {(() => {
                    const totalCount = Number(pagination?.totalCount) || 0;
                    const totalPages = Number(pagination?.totalPages) || 1;
                    const currentPage = Number(pagination?.currentPage) || 1;
                    const pageSize = totalPages > 0 ? Math.ceil(totalCount / totalPages) : 0;

                    const start = totalCount === 0 ? 0 : (currentPage - 1) * pageSize + 1;
                    const end = Math.min(currentPage * pageSize, totalCount);

                    return (
                      <>
                        {start} - {end} &nbsp;OF&nbsp; {totalCount}
                      </>
                    );
                  })()}
                </span>
              </div>
              <div className="flex items-center space-x-2">
                <button
                  type="button"
                  className="px-3 py-1 rounded-md border-2 border-gray-300 hover:border-[#07b553] flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={handleFirst}
                  disabled={pagination?.currentPage === 1}
                >
                  <DoubleLeftOutlined className="text-xs" />
                </button>

                <button
                  type="button"
                  className="px-3 py-1 rounded-md border-2 border-gray-300 hover:border-[#07b553] flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={handlePrevious}
                  disabled={pagination?.currentPage === 1}
                >
                  <LeftOutlined className="text-xs" />
                </button>

                <div className="flex items-center space-x-1">
                  {generatePageNumbers().map((page, index) => (
                    <button
                      key={index}
                      className={`px-3 py-1 rounded-md min-w-[40px] ${page === pagination?.currentPage
                        ? 'text-[#07b553] font-semibold'
                        : page === '...'
                          ? 'cursor-default text-gray-400'
                          : 'hover:text-[#07b553] text-gray-600'
                        }`}
                      onClick={() => typeof page === 'number' && handlePageChange(page)}
                      disabled={page === '...'}
                    >
                      {page}
                    </button>
                  ))}
                </div>

                <button
                  className="px-3 py-1 rounded-md border-2 border-gray-300 hover:border-[#07b553] flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={handleNext}
                  disabled={pagination?.currentPage === pagination?.totalPages}
                >
                  <RightOutlined className="text-xs" />
                </button>

                <button
                  className="px-3 py-1 rounded-md border-2 border-gray-300 hover:border-[#07b553] flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={handleLast}
                  disabled={pagination?.currentPage === pagination?.totalPages}
                >
                  <DoubleRightOutlined className="text-xs" />
                </button>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </Loadercomponent>
    </Header>
  );
};

export default SalesReturnReport;